import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormControl, Button, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

import { setRefreshTimer } from 'store/ecosystems/actions';

dayjs.extend(utc);
dayjs.extend(timezone);

const RefreshTimer = ({ disabled, value, onRefresh, onChangeRefresh, onExport }) => {
  const now = dayjs();

  // Get UTC offset in hours
  const utcOffsetInHours = now.utcOffset() / 60;

  // Format the UTC offset for display
  const formattedOffset = utcOffsetInHours >= 0 ? `(UTC +${utcOffsetInHours}hr)` : `(UTC ${utcOffsetInHours}hr)`;

  return (
    <Stack direction="row" alignItems="center" gap={2.5}>
      <Stack direction="row" alignItems="center" sx={{ whiteSpace: 'nowrap' }} gap={1.125}>
        <Typography sx={{ fontSize: 20, fontWeight: 500 }}>{now.format('MMMM DD, YYYY')}</Typography>
        <Typography sx={{ fontSize: 14 }}>
          {now.format('HH:mm:ss')} {formattedOffset}
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" gap={1.5}>
        <FormControl fullWidth disabled={disabled} sx={{ height: 50 }}>
          <InputLabel id="refresh-timer">Refresh Interval</InputLabel>
          <Select
            label="Refresh Interval"
            labelId="refresh-timer"
            value={value}
            onChange={(e) => onChangeRefresh(e.target.value)}
            sx={{ width: 160 }}
          >
            <MenuItem value={0}>Off</MenuItem>
            <MenuItem value={1}>1 minute</MenuItem>
            <MenuItem value={5}>5 minutes</MenuItem>
            <MenuItem value={10}>10 minutes</MenuItem>
          </Select>
        </FormControl>
        <Button
          variant="contained"
          onClick={onRefresh}
          disabled={disabled}
          sx={{ width: 50, height: 50, minWidth: 50 }}
        >
          <ReplayIcon />
        </Button>
      </Stack>
      {!!onExport && <Button startIcon={<SaveAltIcon />}>EXPORT</Button>}
    </Stack>
  );
};

RefreshTimer.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.number,
  onRefresh: PropTypes.func,
  onChangeRefresh: PropTypes.func,
  onExport: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
  onChangeRefresh: (value) => dispatch(setRefreshTimer(value)),
});

export default connect(null, mapDispatchToProps)(RefreshTimer);
